import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DirectBoss } from '../../services/direct-boss.service';

interface DirectBossState {
  directBosses: DirectBoss[];
  loading: boolean;
  page: number;
  limit: number;
  total: number;
  query: string;
  sortBy: string;
  defaultSort: 'asc' | 'desc';
  fetch: number;
  isDirectBoss: boolean;
  bossId?: number | null;
}

const initialState: DirectBossState = {
  directBosses: [],
  loading: false,
  page: 0,
  limit: 25,
  total: 0,
  query: '',
  sortBy: 'id',
  defaultSort: 'asc',
  fetch: 0,
  isDirectBoss: false,
  bossId: null,
};

const directBossSlice = createSlice({
  name: 'directBoss',
  initialState,
  reducers: {
    setDirectBosses: (state, action: PayloadAction<DirectBoss[]>) => {
      state.directBosses = action.payload || [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
      state.page = 0;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
      state.page = 0;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setDefaultSort: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.defaultSort = action.payload;
    },
    setFetch: (state, action: PayloadAction<boolean>) => {
      state.fetch = state.fetch + 1;
    },
    setIsDirectBoss: (state, action: PayloadAction<{ isDirectBoss: boolean; bossId?: number | null }>) => {
      state.isDirectBoss = action.payload.isDirectBoss;
      state.bossId = action.payload.bossId ?? state.bossId ?? null;
    },
    resetState: (state) => {
      return { ...initialState };
    },
  },
});

export const {
  setDirectBosses,
  setLoading,
  setPage,
  setLimit,
  setTotal,
  setQuery,
  setSortBy,
  setDefaultSort,
  setFetch,
  setIsDirectBoss,
  resetState,
} = directBossSlice.actions;

export default directBossSlice.reducer;
